// import {
//   Dialog,
//   DialogContent,
//   DialogActions,
//   Grid,
//   DialogTitle,
//   TextField,
//   FormControl,
//   InputLabel,
//   MenuItem,
//   Select,
//   Button,
//   Autocomplete
// } from '@mui/material'
// import { GreenText } from 'components'
// import { Formik } from 'formik'

// interface DamageDetailsEditDialogProps {
//   initialValues: any
//   open: boolean
//   onClose: () => void
//   onSave: (values: any) => void
//   isLoading: boolean
// }

// export default function DamageDetailsEditDialog({
//   open,
//   onClose,
//   onSave,
//   isLoading,
//   initialValues
// }: DamageDetailsEditDialogProps) {
//   return (
//     <Dialog open={open} onClose={onClose} fullWidth maxWidth='sm'>
//       <Formik
//         enableReinitialize
//         initialValues={initialValues}
//         validateOnChange
//         validateOnBlur={false}
//         onSubmit={(values, formikHelpers) => {
//           onSave(values)
//           formikHelpers.setSubmitting(false)
//         }}
//       >
//         {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, touched, values }) => (
//           <form onSubmit={handleSubmit}>
//             <DialogTitle>Edit Damage Details</DialogTitle>
//             <DialogContent>
//               <Grid container spacing={2}>
//                 <Grid item xs={12}>
//                   <TextField
//                     disabled={isLoading || isSubmitting}
//                     error={Boolean(touched.damageDescription && errors.damageDescription)}
//                     fullWidth
//                     helperText={
//                       touched.damageDescription && typeof errors.damageDescription === 'string'
//                         ? errors.damageDescription
//                         : undefined
//                     }
//                     label='Damage Description'
//                     minRows={6}
//                     multiline
//                     name='damageDescription'
//                     onBlur={handleBlur}
//                     onChange={handleChange}
//                     value={values.damageDescription || ''}
//                     InputLabelProps={{ shrink: true }}
//                     sx={{ mt: 1 }}
//                   />
//                 </Grid>

//                 <Grid item xs={12} />

//                 <Grid item xs={12}>
//                   <Autocomplete
//                     id='damageStatus'
//                     options={['Resolved', 'Unresolved']}
//                     getOptionLabel={option => option}
//                     value={values.damageStatus || ''}
//                     onChange={(event, value) => {
//                       handleChange({
//                         target: {
//                           name: 'damageStatus',
//                           value: value
//                         }
//                       })
//                     }}
//                     renderInput={params => <TextField {...params} label='Status' />}
//                     sx={{ mt: 1 }}
//                   />
//                 </Grid>
//               </Grid>
//             </DialogContent>

//             <Grid item xs={12} sx={{ p: 2 }}>
//               <GreenText variant='outlined'>
//                 {`**Damage Description:**

// Is a required free-type text field that allows users to input details
// about the vehicles reported damage

// Max character count: 1000 characters.

// **Status Drop-Down:**

// The status drop down displays the following options:

// - Resolved: Selecting this will set the reported damaged vehicle
// record to Resolved

// - Unresolved: Selecting this will set the reported damaged Vehicle
// record to Unresolved

// **CANCEL Button:**

// Clicking the CANCEL button will close the dialog and not save any
// changes

// **SAVE Button:**

// Clicking the SAVE button will save any changes.

//                 `}
//               </GreenText>
//             </Grid>

//             <DialogActions sx={{ justifyContent: 'flex-end', p: 2 }}>
//               <Button variant='text' color='error' onClick={onClose}>
//                 CANCEL
//               </Button>
//               <Button type='submit' color='primary' variant='contained' disabled={isLoading || isSubmitting}>
//                 Save
//               </Button>
//             </DialogActions>
//           </form>
//         )}
//       </Formik>
//     </Dialog>
//   )
// }

// import { Dialog, DialogContent, DialogActions, Grid, DialogTitle, TextField, Autocomplete, Button } from '@mui/material'
// import { GreenText } from 'components'
// import { Formik } from 'formik'

// interface DamageDetailsEditDialogProps {
//   initialValues: any
//   open: boolean
//   onClose: () => void
//   onSave: (values: any) => void
//   isLoading: boolean
// }

// export default function DamageDetailsEditDialog({
//   open,
//   onClose,
//   onSave,
//   isLoading,
//   initialValues
// }: DamageDetailsEditDialogProps) {
//   return (
//     <Dialog open={open} onClose={onClose} fullWidth maxWidth='sm'>
//       <Formik
//         enableReinitialize
//         initialValues={initialValues}
//         validateOnChange
//         validateOnBlur={false}
//         onSubmit={(values, formikHelpers) => {
//           onSave(values)
//           formikHelpers.setSubmitting(false)
//         }}
//       >
//         {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, touched, values }) => (
//           <form onSubmit={handleSubmit}>
//             <DialogTitle>Edit Damage Details</DialogTitle>
//             <DialogContent>
//               <Grid container spacing={2}>
//                 <Grid item xs={12}>
//                   <TextField
//                     disabled={isLoading || isSubmitting}
//                     error={Boolean(touched.damageDescription && errors.damageDescription)}
//                     fullWidth
//                     helperText={
//                       touched.damageDescription && typeof errors.damageDescription === 'string'
//                         ? errors.damageDescription
//                         : undefined
//                     }
//                     label='Damage Description'
//                     minRows={6}
//                     multiline
//                     name='damageDescription'
//                     onBlur={handleBlur}
//                     onChange={handleChange}
//                     value={values.damageDescription || ''}
//                     InputLabelProps={{ shrink: true }}
//                     sx={{ mt: 1 }}
//                   />
//                 </Grid>

//                 <Grid item xs={12} />

//                 <Grid item xs={12}>
//                   <Autocomplete
//                     id='damageStatus'
//                     options={['Resolved', 'Unresolved']}
//                     getOptionLabel={option => option}
//                     value={values.damageStatus || ''}
//                     onChange={(event, value) => {
//                       handleChange({
//                         target: {
//                           name: 'damageStatus',
//                           value: value
//                         }
//                       })
//                     }}
//                     renderInput={params => <TextField {...params} label='Status' />}
//                     sx={{ mt: 1 }}
//                   />
//                 </Grid>
//               </Grid>
//             </DialogContent>

//             <Grid item xs={12} sx={{ p: 2 }}>
//               <GreenText variant='outlined'>
//                 {`**Damage Description:**

// Is a required free-type text field that allows users to input details
// about the vehicle's reported damage

// Max character count: 1000 characters.

// **Status Drop-Down:**

// The status drop-down displays the following options:

// - Resolved: Selecting this will set the reported damaged vehicle
// record to Resolved

// - Unresolved: Selecting this will set the reported damaged Vehicle
// record to Unresolved

// **CANCEL Button:**

// Clicking the CANCEL button will close the dialog and not save any
// changes

// **SAVE Button:**

// Clicking the SAVE button will save any changes.`}
//               </GreenText>
//             </Grid>

//             <DialogActions sx={{ justifyContent: 'flex-end', p: 2 }}>
//               <Button variant='text' color='error' onClick={onClose}>
//                 CANCEL
//               </Button>
//               <Button type='submit' color='primary' variant='contained' disabled={isLoading || isSubmitting}>
//                 Save
//               </Button>
//             </DialogActions>
//           </form>
//         )}
//       </Formik>
//     </Dialog>
//   )
// }

import { VehicleDamageDetailsDto } from 'dtos' // Adjust the import path accordingly
import { Dialog, DialogContent, DialogActions, Grid, DialogTitle, TextField, Autocomplete, Button } from '@mui/material'
import { GreenText } from 'components'
import { Formik } from 'formik'

interface DamageDetailsEditDialogProps {
  initialValues: VehicleDamageDetailsDto // Make sure it's of type VehicleDamageDetailsDto
  open: boolean
  onClose: () => void
  onSave: (values: VehicleDamageDetailsDto) => void // Make sure the onSave function accepts VehicleDamageDetailsDto
  isLoading: boolean
}

export default function DamageDetailsEditDialog({
  open,
  onClose,
  onSave,
  isLoading,
  initialValues
}: DamageDetailsEditDialogProps) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth='sm'>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validateOnChange
        validateOnBlur={false}
        onSubmit={(values, formikHelpers) => {
          onSave(values)
          formikHelpers.setSubmitting(false)
        }}
      >
        {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, touched, values }) => (
          <form onSubmit={handleSubmit}>
            <DialogTitle>Edit Damage Details</DialogTitle>
            <DialogContent>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    disabled={isLoading || isSubmitting}
                    error={Boolean(touched.damageDescription && errors.damageDescription)}
                    fullWidth
                    helperText={
                      touched.damageDescription && typeof errors.damageDescription === 'string'
                        ? errors.damageDescription
                        : undefined
                    }
                    label='Damage Description'
                    minRows={6}
                    multiline
                    name='damageDescription'
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.damageDescription || ''}
                    InputLabelProps={{ shrink: true }}
                    sx={{ mt: 1 }}
                  />
                </Grid>

                <Grid item xs={12} />

                <Grid item xs={12}>
                  <Autocomplete
                    id='damageStatus'
                    options={['Resolved', 'Unresolved']}
                    getOptionLabel={option => option}
                    value={values.damageStatus || ''}
                    onChange={(event, value) => {
                      handleChange({
                        target: {
                          name: 'damageStatus',
                          value: value
                        }
                      })
                    }}
                    renderInput={params => <TextField {...params} label='Status' />}
                    sx={{ mt: 1 }}
                  />
                </Grid>
              </Grid>
            </DialogContent>

            <Grid item xs={12} sx={{ p: 2 }}>
              <GreenText variant='outlined'>
                {`**Damage Description:**

Is a required free-type text field that allows users to input details 
about the vehicle's reported damage

Max character count: 1000 characters.

**Status Drop-Down:** 

The status drop-down displays the following options:

- Resolved: Selecting this will set the reported damaged vehicle 
record to Resolved

- Unresolved: Selecting this will set the reported damaged Vehicle 
record to Unresolved

**CANCEL Button:**

Clicking the CANCEL button will close the dialog and not save any 
changes

**SAVE Button:**

Clicking the SAVE button will save any changes.`}
              </GreenText>
            </Grid>

            <DialogActions sx={{ justifyContent: 'flex-end', p: 2 }}>
              <Button variant='text' color='error' onClick={onClose}>
                CANCEL
              </Button>
              <Button type='submit' color='primary' variant='contained' disabled={isLoading || isSubmitting}>
                Save
              </Button>
            </DialogActions>
          </form>
        )}
      </Formik>
    </Dialog>
  )
}
